import { PendingAction } from 'app/page/orders/redux/model/pending-action';
import { PendingType } from 'app/page/orders/redux/model/pending-type';

export class PendingActionUtils {
    public static withStartedPendingAction(
        pendingType: PendingType,
        pendingActions: PendingAction[],
        id?: string,
    ): PendingAction[] {
        return [...PendingActionUtils.withRemovedPendingAction(pendingType, pendingActions), { type: pendingType, id }];
    }

    public static withRemovedPendingAction(
        pendingType: PendingType,
        pendingActions: PendingAction[],
        id?: string,
    ): PendingAction[] {
        return pendingActions.filter(
            (pendingAction) => !(pendingAction.type === pendingType && pendingAction.id === id),
        );
    }

    public static withPendingActionFailure(
        { type, reason, id }: { type: PendingType; reason: any; id?: string },
        pendingActions: PendingAction[],
    ): PendingAction[] {
        return pendingActions.map((pendingAction) =>
            pendingAction.type === type && pendingAction.id === id
                ? { ...pendingAction, failed: true, failureReason: reason, id }
                : pendingAction,
        );
    }

    public static isActionWithIdPending(
        pendingActions: PendingAction[],
        ...pendingTypes: Pick<PendingAction, 'type' | 'id'>[]
    ): boolean {
        return pendingActions.some((pendingAction) =>
            pendingTypes.some(
                (pendingType) => pendingType.type === pendingAction.type && pendingType.id === pendingAction.id,
            ),
        );
    }

    public static isActionPending(pendingActions: PendingAction[], ...pendingType: PendingType[]): boolean {
        return pendingActions.some(
            (pendingAction) => pendingType.includes(pendingAction.type) && !pendingAction.failed,
        );
    }

    public static hasFailedActions(pendingActions: PendingAction[]): boolean {
        return pendingActions.some((pendingAction) => pendingAction.failed);
    }

    public static hasPendingActions(pendingActions: PendingAction[]): boolean {
        return pendingActions
            .filter((pendingAction) => pendingAction.type !== PendingType.LOAD_CUSTOMER_INFORMATION)
            .some((pendingAction) => !pendingAction.failed);
    }
}
